// test970
(970 && 0);
